import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave/index";
import {
  ICunsultarFaturaProps,
  IFaturaResponse,
  IFormStatusPagamento,
  IPageFaturaDTO,
  IReembolsoResponse,
} from "../../types/pagamento";
import { FormaPagamentoEnum } from "../../enums/formaPagamento";
import { IReembolsoProps } from "../../types/agendamento";
import { IContaIuguDTO } from "../../types/contaIugo";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/pagamento";

export class Pagamento {
  static async consultarFatura(
    props: ICunsultarFaturaProps
  ): Promise<AxiosResponse<IPageFaturaDTO>> {
    let params = "";
    const { uuidAgendamento, ...rest } = props;

    if (props) {
      const values = removeEmpty(rest);
      params = new URLSearchParams(values).toString();
    }
    return ApiBrave.get(
      `${basePath}/agendamento/${uuidAgendamento}/consultar-fatura?${params}`
    );
  }

  static async listarContas(): Promise<AxiosResponse<IContaIuguDTO[]>> {
    return ApiBrave.get(`${basePath}/listar-contas`);
  }

  static async cancelarPagamento({
    uuidAgendamento,
  }: {
    uuidAgendamento: string;
  }): Promise<AxiosResponse<IReembolsoResponse>> {
    return ApiBrave.put(
      `${basePath}/agendamento/${uuidAgendamento}/cancelar-fatura`
    );
  }

  static async statusPagamento({ form }: { form: IFormStatusPagamento }) {
    return ApiBrave.get(`${basePath}/status-pagamento`, form);
  }

  static async gerarFatura({
    uuidAgendamento,
    formaPagamento,
  }: {
    uuidAgendamento: string;
    formaPagamento: FormaPagamentoEnum;
  }): Promise<AxiosResponse<IFaturaResponse>> {
    return ApiBrave.post(
      `${basePath}/agendamento/${uuidAgendamento}/gerar-fatura?formaPagamento=${formaPagamento}`
    );
  }

  static async reembolso(
    props: IReembolsoProps
  ): Promise<AxiosResponse<IReembolsoResponse>> {
    const { uuid, ...rest } = props;
    return ApiBrave.post(`${basePath}/agendamento/${uuid}/reembolsar`, rest);
  }
}
